<template>
  <div id="depManagement">
        <i-col span="24" style="padding: 0 20px;">
            <div class="query-bar">
                <Form ref="formInline" class="rightTop" :model="formInline" inline :label-width="80">
                		<h4>部门管理</h4>
                    <Button class="addBtn" type="primary" @click="addDepartment" style="margin-top: 0;margin-left: 20px;">新增部门</Button>
                    <Form-item label="部门名称" prop="name">
                        <Select v-model="formInline.name" clearable style="width:162px;">
                            <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                        </Select>
                        <!-- <Input v-model="formInline.name" :maxlength="16" placeholder="请输入部门名称"></Input> -->
                    </Form-item>
                    <Form-item label="部门编号" prop="code">
                        <Input v-model="formInline.code" :maxlength="16" placeholder="请输入部门编号"></Input>
                    </Form-item>
                    <Form-item label="部门简称" prop="shortname">
                        <Input v-model="formInline.shortname" :maxlength="16" placeholder="请输入部门简称"></Input>
                    </Form-item>
                    <Button type="primary" @click="submitSearch(actionPage)">搜索</Button>

                    
                </Form>
            </div>
            <Modal v-model="modal1">
                <div slot="header">{{updateTitle}}</div>
                <Form ref="depManagerForm" :model="formItem" :label-width="80" :rules="validate_dep_rules">
                    <Form-item label="部门名称" prop="name">
                        <Input v-model="formItem.name" :maxlength="16" class="width90"  placeholder="请输入部门名称"></Input>
                    </Form-item>
                    <Form-item label="部门编号" prop="code">
                        <Input v-model="formItem.code" :maxlength="16" class="width90" :disabled="updateTitle=='编辑部门'?true:false" @on-blur="checkName('code')" placeholder="请输入部门编号"></Input>
                    </Form-item>
                    <Form-item label="部门简称" prop="shortname">
                        <Input v-model="formItem.shortname" :maxlength="16" class="width90" placeholder="请输入部门简称"></Input>
                    </Form-item>
                    <Form-item label="部门级别" class="width90" prop="level">
                        <Select clearable v-model="formItem.level">
                            <Option :value="1">1级</Option>
                            <Option :value="2">2级</Option>
                        </Select>
                    </Form-item>
                    <Form-item label="部门等级1" prop="level1">
                        <Input v-model="formItem.level1" :maxlength="16" class="width90" placeholder="请输入部门等级1"></Input>
                    </Form-item>
                    <Form-item label="部门等级2" prop="level2">
                        <Input v-model="formItem.level2" :maxlength="16" class="width90" placeholder="请输入部门等级2"></Input>
                    </Form-item>
                    <!--<Form-item label="部门等级3" prop="level3">-->
                        <!--<Input v-model="formItem.level3" :maxlength="16" class="width90" placeholder="请输入部门等级3"></Input>-->
                    <!--</Form-item>-->
                    <!--<Form-item label="部门等级4" prop="level4">-->
                        <!--<Input v-model="formItem.level4" :maxlength="16" class="width90" placeholder="请输入部门等级4"></Input>-->
                    <!--</Form-item>-->
                    <Form-item label="负责人" prop="leader">
                        <!--<Input v-model="formItem.leader" :maxlength="8" class="width90" placeholder="请输入负责人名称"></Input>-->
                        <div style="width: 75%;height: 32px;border: 1px solid #dddee1;display: inline-block;font-size: 12px;padding-left:7px">
                            <p >{{formItem.leader}}</p>
                        </div>
                        <Button type="primary" @click="changePeople" style="float: right">选择人员</Button>
                    </Form-item>
                    <Form-item label="联系电话" prop="telephone">
                        <Input v-model="formItem.telephone"  class="width90" placeholder="请输入11位数手机号码或固定电话(含区号)如:(0757-63863722)"></Input>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button v-if="btnSave" type="primary" @click="saveDep('depManagerForm')">保存</Button>
                    <Button v-if="btnChange" type="primary" @click="modifyDepartment('depManagerForm')">修改</Button>
                    <Button  @click="cancel">取消</Button>
                </div>
            </Modal>
            <div class="center">
                <Table border :data="departmentData" :columns="theadArr" stripe></Table>
                <Page class="pull-right" :total="totalSize" :current="page" :page-size="pageSize"  show-total @on-change="changePage"></Page>
            </div>
            <selectPerson v-model="selectPeopleShow" :currentSelectData="personList"  @on-ok="handleSelectPerson" ></selectPerson>
        </i-col>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import selectPerson from "../selectPerson"
export default {
        components: {
            'selectPerson':selectPerson
        },
        data () {
            const reEXP_tel = /^((0\d{2,3}-[1-9]\d{6,7})|(1\d{10}))$/;
            const validate_telephone = (rule,value,callback) =>{
                if(value == ''){
                    callback(new Error('联系电话不能为空！'))
                }else if(!reEXP_tel.test(value)){
                    callback(new Error('联系电话格式或号码位数不正确！'))
                }else {callback()}
            }
            return {
                validate_dep_rules:{
                    name:[{required:true,message:'部门名称不能为空！',trigger:'blur'}],
                    code:[{required:true,message:'部门编号不能为空！',trigger:'blur'}],
                    leader:[{required:true,message:'部门负责人不能为空！',trigger:'blur'}],
                    telephone:[{required:true,validator:validate_telephone,trigger:'blur'}],
                },
                urlDepartmentList:'/sys/department/list',
                urlDepartmentAddList:'/sys/department/new',
                urlDepartmentUpdateList:'/sys/department/edit',
                urlDepartmentDeleteList:'/sys/department/delete',
                formItem: {},
                departmentList:[],
                updateTitle: "",
                formInline: {
                    name:'',
                    code:'',
                    level:'',
                    level1:'',
                    level2:'',
//                    level3:'',
//                    level4:'',
                    leader:'',
                    telephone:'',
                    shortname:''
                },
                departmentData:[],
                theadArr: [{
                    title: "部门名称",
                    key: "name"
                }, {
                    title: "部门简称",
                    key: "shortname"
                }, {
                    title: "部门编号",
                    key: "code"
                }, {
                    title: "当前部门级别",
                    key: "level",
                    align: 'center',
//                    render: (h,params) => {
//                        return params.row.level + "级部门"
//                    }
                }, {
                    title: "部门等级1",
                    key: "level1"
                }, {
                    title: "部门等级2",
                    key: "level2"
                } /*{
                    title: "部门等级3",
                    width: 200,
                    key: "level3"
                }, {
                    title: "部门等级4",
                    width: 200,
                    key: "level4"
                }, {
                 title: "部门等级5",
                 width: 200,
                 key: "level5"
                 }*/, {
                    title: "负责人",
                    key: "leader"
                }, {
                    title: "联系方式",
                    key: "telephone"
                }, {
                    title: '用户操作',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                },
                                style: {
                                    marginRight : '5px'
                                },
                                on: {
                                    click: () => {
                                        this.edit(params.row,params.index)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                },
                                style: {
                                    marginRight : '5px'
                                },
                                on: {
                                    click: () => {
                                        this.delDepartment(params.row)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }],
                btnSave: false,
                btnChange: false,
                modal1: false,
                selectPeopleShow:false,
                SelectPersonData:{},
                actionPage: 1,
                totalSize:0,//总条数
                pageSize:10,//每页显示数
                page:1,//当前页
            }
        },
        computed:{
            personList:function () {
                let obj = {};
                obj=this.SelectPersonData
                return obj;
            }
        },
        watch: {
            totalSize(a) {
                console.log("总条数",a);
            },
            page(a) {
                console.log("在第几页",a);
            }
        },
        methods: {
            ...mapMutations(["CHANGE_PEOPLE"]),
			    	changQuery(){
			    		this.submitSearch(this.actionPage)
			    	},
			    	changePeople(){
			    		this.selectPeopleShow = true;
			    		this.CHANGE_PEOPLE();
			    	},
            getDepartmentList: function() {
                var that = this;
                let params = {};
                params.data = {}
                params.url = '/sys/department/list';
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                  res = res.data;
                  that.departmentList = res.result.result;
                  console.log(that.departmentList);
                }
                this.ajaxPost(params);
            },
            handleSelectPerson(data){
                console.log("data is",data);
                this.SelectPersonData=data
                this.formItem.leader=data.realname

            },
            submitSearch: function(page) {
                console.log("page is ",page);
                page = page == '' || page == undefined ? this.page:page;
                var that = this;
                var params = {};
                params.data = {page:page,pageSize:this.pageSize,order : {"_id":-1}, searchValue : {}}
                params.url = this.urlDepartmentList;
                if(this.formInline.name !=''){
                    params.data.searchValue.name=this.formInline.name;
                }
                if(this.formInline.code !=''){
                    params.data.searchValue.code=this.formInline.code+"|#|like";
                }
                if(this.formInline.level !=''){
                    params.data.searchValue.level=this.formInline.level+"|#|like";
                }
                if(this.formInline.shortname !=''){
                    params.data.searchValue.shortname=this.formInline.shortname+"|#|like";
                }
                if(this.formInline.level1 !=''){
                    params.data.searchValue.level1=this.formInline.level1+"|#|like";
                }
                if(this.formInline.level2 !=''){
                    params.data.searchValue.level2=this.formInline.level2+"|#|like";
                }
//                if(this.formInline.level3 !=''){
//                    params.data.searchValue.level3=this.formInline.level3+"|#|like";
//                }
//                if(this.formInline.level4 !=''){
//                    params.data.searchValue.level4=this.formInline.level4+"|#|like";
//                }
                if(this.formInline.leader !=''){
                    params.data.searchValue.leader=this.formInline.leader+"|#|like";
                }
                if(this.formInline.telephone !=''){
                    params.data.searchValue.telephone=this.formInline.telephone+"|#|like";
                }
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    res = res.data;
                    that.getDepartmentList();
                    that.departmentData = res.result.result;
                    that.totalSize = res.result.totalSize;
                    that.page = res.result.page;
                }
                this.ajaxPost(params);
            },
            changePage: function(page) {
                this.submitSearch(page);
                this.actionPage = page;
            },
            addDepartment: function() {
                this.formItem={
                    name:'',
                    code:'',
                    level:'',
                    level1:'',
                    level2:'',
//                    level3:'',
//                    level4:'',
                    leader:'',
                    telephone:'',
                    shortname:''
                };
                this.updateTitle = "新增部门";
                this.btnChange = false;
                this.btnSave = true;
                this.modal1 = true;
                this.SelectPersonData={}
            },
            //保存新增部门
            saveDep(formName) {
                let that = this;
                this.$refs[formName].validate((valid) =>{
                	console.log("djalks");
                    if(valid){
                        let params = {};
                        params.data = {};
                        params.url = this.urlDepartmentAddList;
                        params.data = that.formItem;
                        params.token = window.localStorage.getItem("token");
                        params.success = function(res){
                            res = res.data;
                            console.log(res);
                            if(res.code == '0000') {
                                    that.$Message.success({
                                        content: '新增成功'
                                    });
                                    that.modal1=false;
                            }else{
                            	that.$Message.error({
                                content: res.message
                            	});
                            }
                            that.submitSearch(parseInt(that.actionPage));
                        };
                        params.error = function (res) {
                              if(res.code == '0002'){
                                  that.$Message.error({
                                      content: res.message + " 请重新输入"
                                  });
                              }
                        }
                    that.ajaxPost(params);
                    }
                })
            },
            //删除部门
            delDepartment: function(data) {
                let that = this;
                this.$Modal.confirm({
                    content:'确认删除该个部门？',
                    onOk:function () {
                    let params = {};
                    params.data = {};
                    params.data._id= data._id.toString();
                    params.token = window.localStorage.getItem("token");
                    params.url = that.urlDepartmentDeleteList;
                    params.success=function(res){
                        //res = data.res;
                        switch(res.data.code) {
                            case '0000':
                                that.$Message.success({
                                    content: '删除成功'
                                });
                                break;
                            default:
                                that.$Message.success({
                                    content: res.message + " 删除失败"
                                });
                        }
                        that.submitSearch(parseInt(that.actionPage));
                    }
                    that.ajaxPost(params);
                    }
                })
            },
            cancel () {
                this.modal1=false;
            },
            edit: function(row,index) {
                this.updateTitle = "编辑部门";
                this.formItem.name = row.name;
                this.btnSave = false;
                this.btnChange = true;
                this.modal1 = true;
                this.formItem = JSON.parse(JSON.stringify(row));
                delete this.formItem['_index'];
                delete this.formItem['_rowKey'];
            },
            //保存修改部门
            modifyDepartment: function(formName) {
                let that = this;
                this.$refs[formName].validate((valid) =>{
                    if(valid){
                        let params = {};
                        params.url = that.urlDepartmentUpdateList;
                        params.token = window.localStorage.getItem("token");
                        params.data=that.formItem;
                        params.success = function(res){
                            res = res.data;
                            if(res.code == '0000') {
                                    that.$Message.success({
                                        content: '修改成功'
                                    });
                                    that.modal1=false;
                            }
                        that.submitSearch(parseInt(that.actionPage));
                        };
                        params.error = function (res) {
                            res = res.data;
                            if(res.code == '0002'){
                                that.$Message.warning({
                                    content: res.message + " 请重新输入"
                                });
                            }
                        }
                        that.ajaxPost(params);
                    }
                })
            },
            checkName: function(data) {
                var that = this;
                var params = {};
                console.log(data);
                params.data = {
                    page : 1,
                    order : {"_id":-1},
                    searchValue : {}
                }
                if( data === "name"){
                    if(this.formItem.name === ""){return};
                    params.data.searchValue.name = this.formItem.name;
                }
                if( data === "code"){
                    if(this.formItem.code === ""){return};
                    params.data.searchValue.code = this.formItem.code;
                }
                params.token = window.localStorage.getItem("token");
                params.url = this.urlDepartmentList;
                params.success = function(res) {
                    res = res.data;
                    if(parseInt(res.result.totalSize) !== 0){
                        that.$Message.warning({
                            content: '已被注册'
                        });
                    }else{
                        that.$Message.success({
                            content: '可用'
                        });
                    }
                }
                this.ajaxPost(params);
            },
        },
        mounted: function() {
            this.submitSearch(this.page);
        }
    }
</script>

<style lang="scss">
	#depManagement{
		.ivu-table-border td, .ivu-table-border th{
    		text-align: center;
    }
    .ivu-table-border th{
    	height: 50px;
    	font-size: 16px;
    }
    .ivu-page{
    	margin-top: 30px;
    }
	}
</style>

<style lang="scss" scoped>
    #depManagement{
    	.query-bar{
    		background: transparent;
    		height: 80px;
    		padding-top: 20px;
    		margin-bottom: 30px;
    		border-bottom: 1px solid #e9eaec;
    	}
    	.ivu-table-border td, .ivu-table-border th{
    		text-align: center;
    	}
    	.rightTop{
    		h4{
    			font-size: 18px;
    			color: #45AAF9;
    			float: left;
    			text-align: left;
    		}
    		text-align: left;
    		.ivu-form-item{
    			text-align: left;
    		}
    	}
	    .ivu-form-item {
	        margin-bottom: 0px;
	    }
    }
</style>




// WEBPACK FOOTER //
// src/components/userMana/depart.vue